import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { EMPTY_OBJECT } from '../../../app.constants';

var ClickStreamEvent = /*#__PURE__*/function () {
  function ClickStreamEvent(type) {
    _classCallCheck(this, ClickStreamEvent);

    this.eventType = type;
    this.eventProperties = EMPTY_OBJECT;
  }

  _createClass(ClickStreamEvent, [{
    key: "getEventType",
    value: function getEventType() {
      return this.eventType;
    }
  }, {
    key: "getEventProperties",
    value: function getEventProperties() {
      return this.eventProperties;
    }
  }, {
    key: "setEventProperties",
    value: function setEventProperties(eventProperties) {
      this.eventProperties = eventProperties;
      return this;
    }
  }]);

  return ClickStreamEvent;
}();

export default ClickStreamEvent;